module.exports = __webpack_public_path__ + "static/media/procesos.6f5e7a87.svg";